import cloneDeep from 'lodash/fp/cloneDeep'
import {
  SUBMITTING_APPROVE_PROFILE
  , SUBMITTED_APPROVE_PROFILE
} from './adviserProfilePromoteToApprovedActions'

const initialState = {
  submitting: false,
  submitted: false
}

export default function (state = initialState, action) {
  var newState = cloneDeep(state)
  switch (action.type) {
    case SUBMITTING_APPROVE_PROFILE:
      newState.promoteToApproved.submitting = true
      newState.promoteToApproved.submitted = false
      return newState
    case SUBMITTED_APPROVE_PROFILE:
      newState.promoteToApproved.submitting = false
      newState.promoteToApproved.submitted = true
      newState.edited = false
      return newState
  }
  return state
}
